import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { useMemo, useState } from 'react';
import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';

const fixedValues = {
  fontSize: 14,
  checkboxGap: 10,
  padding10: 10,
  marginTop10: 10,
  marginLeft5: 5,
};

function SignIn_1({ item }) {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const convertedFixedValues = staticComponentValueConverter(fixedValues);
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const customization = staticComponentValueConverter(item?.customization);
  const generalStyle = useSelector(state => state.themeSlice?.branding?.generalStyle);
  const sixthThemeColor = generalStyle?.sixthThemeColor ?? 'black';
  const iconFilter = useMemo(() => HexToHueConverter(sixthThemeColor), []);

  return (
    <div className="h-full w-full overflow-hidden pointer-events-auto ">
      <div className="overflow-auto" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div
          style={{
            textAlign: 'start',
            fontSize: customization?.textSize,
            fontWeight: customization?.textWeight,
            padding: customization?.textPadding,
            color: customization?.textColor,
          }}
        >
          {item?.data?.text || 'Giriş Yap'}
        </div>
        <div
          className="form"
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 15,
            padding: 10,
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'var(--fifthThemeColor)',
              borderRadius: 10,
            }}
          >
            <div
              style={{
                paddingRight: staticValues[15],
                paddingLeft: staticValues[10],
              }}
            >
              <img
                style={{
                  filter: iconFilter,
                }}
                width={20}
                height={20}
                src={customization?.emailIcon}
              />
            </div>
            <div style={{ flex: 1 }}>
              <input
                type={'text'}
                style={{
                  paddingTop: staticValues[10],
                  paddingRight: staticValues[10],
                  paddingBottom: staticValues[10],
                  paddingLeft: 0,
                  width: '99%',
                  backgroundColor: 'var(--fifthThemeColor)',
                  borderRadius: 10,
                  fontSize: staticValues[12],
                }}
                placeholder="Email"
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'var(--fifthThemeColor)',
              borderRadius: 10,
            }}
          >
            <div
              style={{
                paddingRight: staticValues[15],
                paddingLeft: staticValues[10],
              }}
            >
              <img
                style={{
                  filter: iconFilter,
                }}
                width={20}
                height={20}
                src={customization?.passwordIcon}
              />
            </div>
            <div style={{ flex: 1 }}>
              <input
                type={'text'}
                style={{
                  paddingTop: staticValues[10],
                  paddingRight: staticValues[10],
                  paddingBottom: staticValues[10],
                  paddingLeft: 0,
                  width: '99%',
                  backgroundColor: 'var(--fifthThemeColor)',
                  color: '#424242',
                  borderRadius: 10,
                  fontSize: staticValues[12],
                }}
                placeholder="Şifre"
              />
            </div>
            <div
              className="cursor-pointer z-5 !pointer-events-auto"
              onClick={() => {
                setIsPasswordVisible(state => !state);
              }}
              style={{ padding: staticValues[10] }}
            >
              <img
                style={{
                  filter: iconFilter,
                }}
                width={20}
                height={20}
                src={isPasswordVisible ? customization?.passwordOpenIcon : customization?.passwordCloseIcon}
              />
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: staticValues[10] }}>
              <input type="checkbox" checked={true} style={{ display: 'none' }} />

              <svg
                width="24px"
                height="24px"
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
                fill="var(--secondaryThemeColor)"
              >
                <path d="M400,48H112a64.07,64.07,0,0,0-64,64V400a64.07,64.07,0,0,0,64,64H400a64.07,64.07,0,0,0,64-64V112A64.07,64.07,0,0,0,400,48ZM364.25,186.29l-134.4,160a16,16,0,0,1-12,5.71h-.27a16,16,0,0,1-11.89-5.3l-57.6-64a16,16,0,1,1,23.78-21.4l45.29,50.32L339.75,165.71a16,16,0,0,1,24.5,20.58Z" />
              </svg>

              <span
                style={{
                  color: 'var(--secondaryThemeColor)',
                  fontSize: staticValues[14],
                  fontWeight: 500,
                }}
              >
                Beni Hatırla
              </span>
            </div>
          </div>
          <div
            style={{
              backgroundColor: customization?.buttonColor,
              color: customization?.buttonTextColor,
              borderRadius: 10,
              padding: staticValues[10],
              fontSize: staticValues[14],
            }}
          >
            Giriş Yap
          </div>
          <div
            style={{
              fontSize: staticValues[14],
              fontWeight: 500,
              color: customization?.accentColor,
            }}
          >
            Şifremi Unuttum
          </div>
          <div
            style={{
              fontSize: staticValues?.[10],
              fontWeight: 500,
              color: 'var(--secondaryThemeColor)',
            }}
          >
            Devam ederek,
            <span style={{ color: customization?.accentColor }}> Gizlilik Politikasını</span> kabul etmiş olursunuz.
          </div>
        </div>
        <div
          style={{
            marginTop: staticValues[10],
            fontSize: staticValues[14],
            fontWeight: 500,
            color: 'var(--secondaryThemeColor)',
          }}
        >
          Hesabın yok mu?
          <span
            style={{
              fontWeight: 500,
              color: customization?.accentColor,
              marginLeft: staticValues[5],
            }}
          >
            Kayıt Ol
          </span>
        </div>
      </div>
    </div>
  );
}

export default SignIn_1;
